(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tate-wrap-craft"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.tateReady) return;
    const video = root.querySelector('[data-tate-video]');
    const button = root.querySelector('[data-tate-toggle]');
    const error = root.querySelector('[data-tate-error]');
    const retry = root.querySelector('[data-tate-retry]');
    if (!video || !button) return;
    root.dataset.tateReady = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let userPaused = false;
    let manualPlay = false;
    let loaded = false;
    let failed = false;
    const labels = { play: button.dataset.play || 'Play film', pause: button.dataset.pause || 'Pause film', playLabel: button.dataset.playLabel || 'Play Tate Wrap film', pauseLabel: button.dataset.pauseLabel || 'Pause Tate Wrap film' };
    const update = () => {
      button.textContent = video.paused ? labels.play : labels.pause;
      button.setAttribute('aria-label', video.paused ? labels.playLabel : labels.pauseLabel);
    };
    const load = () => {
      if (loaded) return;
      video.src = video.dataset.src;
      video.load();
      loaded = true;
    };
    const play = () => {
      if (failed) return;
      load();
      video.play().catch(() => update());
    };
    video.muted = true;
    video.controls = false;
    button.hidden = false;
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    const onError = () => {
      if (!loaded) return;
      failed = true;
      video.pause();
      if (error) error.hidden = false;
      button.hidden = true;
    };
    video.addEventListener('error', onError);
    button.addEventListener('click', () => {
      if (video.paused) {
        userPaused = false;
        manualPlay = true;
        play();
      } else {
        userPaused = true;
        manualPlay = false;
        video.pause();
      }
    });
    retry?.addEventListener('click', () => {
      failed = false;
      loaded = false;
      error.hidden = true;
      button.hidden = false;
      manualPlay = true;
      userPaused = false;
      play();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      if (visible && !userPaused && (!motion.matches || manualPlay) && !document.hidden) play();
      else video.pause();
    }, { rootMargin: '100px 0px', threshold: 0 });
    observer.observe(video);
    const onVisibility = () => {
      if (document.hidden) video.pause();
      else if (visible && !userPaused && (!motion.matches || manualPlay)) play();
    };
    const onMotion = () => {
      manualPlay = false;
      if (motion.matches) video.pause();
      else if (visible && !userPaused && !document.hidden) play();
    };
    document.addEventListener('visibilitychange', onVisibility);
    motion.addEventListener('change', onMotion);
    root.tateMotionCleanup = () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      motion.removeEventListener('change', onMotion);
      video.pause();
    };
    update();
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-tate-motion]')) init(scope);
    scope.querySelectorAll('[data-tate-motion]').forEach(init);
  };
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-tate-motion]').forEach((root) => root.tateMotionCleanup?.());
  });
})();


  } catch(e) { console.error(e); }
})();
})();
